import React from 'react';

const PlusIcon = ({ width = 24, height = 24, color }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke={color || 'currentColor'} strokeWidth="2">
        <path d="M12 5v14M5 12h14" />
    </svg>
);

export default PlusIcon;
